var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge",class:['badge--theme-' + _vm.theme, 'badge--align-' + _vm.iconPlacement, `badge--type-${_vm.type}`]},[_c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2),(_vm.iconComp)?_c('FontAwesomeIcon',_vm._b({},'FontAwesomeIcon',_vm.iconComp,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }